import { createEvent } from 'effector';
import { createPagination } from '~/shared/lib/pagination';
import { openTraderEditor } from './lib';

export const paginationModel = createPagination();
export const openTrader = createEvent<string>();
openTrader.watch(openTraderEditor);
